import { render, staticRenderFns } from "./DialogRoomSplit.vue?vue&type=template&id=14d07884&scoped=true&"
import script from "./DialogRoomSplit.vue?vue&type=script&lang=js&"
export * from "./DialogRoomSplit.vue?vue&type=script&lang=js&"
import style0 from "./DialogRoomSplit.vue?vue&type=style&index=0&id=14d07884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d07884",
  null
  
)

export default component.exports